import React from "react";
import cookie from "react-cookies";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {
  fetchCollegeList,
  fetchUserLanguages,
  registerNewUser,
} from "../../service/action/audio-track-action";
import "./register.css";
import Alert from "@material-ui/lab/Alert";

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginID: "",
      password: "PASS123",
      baseLanguage: "",
      otherLanguages: "English",
      userPrivilege: "2",
      createdby: "1",
      employeeName: "",
      productIds: "1",
      teamId: "1",
      collegeId: "",
      errormessage: "",
      successMessage: "",
    };
  }

  componentDidMount() {
    if (cookie.load("username")) {
      this.props.history.push("/dashboard");
    }
    this.props.fetchCollegeList();
    this.props.fetchUserLanguages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.AudioToTrackReducer.collegeList.length > 0) {
      if (nextProps.AudioToTrackReducer.success.message !== "") {
        this.setState({
          successMessage: nextProps.AudioToTrackReducer.success.message,
        });
      }
    } else {
      if (nextProps.AudioToTrackReducer.error.message !== "") {
        this.setState({
          errormessage: nextProps.AudioToTrackReducer.error.message,
        });
      }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      loginID,
      password,
      baseLanguage,
      otherLanguages,
      userPrivilege,
      createdby,
      employeeName,
      productIds,
      teamId,
      collegeId,
    } = this.state;
    console.log(
      loginID,
      password,
      baseLanguage,
      otherLanguages,
      userPrivilege,
      createdby,
      employeeName,
      productIds,
      teamId,
      collegeId
    );
    this.props.registerNewUser(
      loginID,
      password,
      baseLanguage,
      otherLanguages,
      userPrivilege,
      createdby,
      employeeName,
      productIds,
      teamId,
      collegeId
    );
  };

  render() {
    const {
      loginID,
      password,
      baseLanguage,
      otherLanguages,
      employeeName,
      collegeId,
      errormessage,
      successMessage,
    } = this.state;
    const { AudioToTrackReducer, SuperAdminReducer } = this.props;
    console.log(AudioToTrackReducer.collegeList);
    console.log(SuperAdminReducer.userLanguages);
    let employeeLanguages = SuperAdminReducer.userLanguages;
    let collegeList = AudioToTrackReducer.collegeList;
    let baseLanguageFilter = employeeLanguages.filter(
      (element) => !element.includes(otherLanguages)
    );
    console.log("Base Languages List", baseLanguageFilter);
    console.log("College List", collegeList);
    return (
      <div className="login-page">
        <div className="containerHolder">
          <form onSubmit={(e) => this.handleSubmit(e)} className="container">
            <h1>Register</h1>
            {errormessage !== "" ? (
              <Alert severity="warning">{errormessage}</Alert>
            ) : null}
            {successMessage !== "" ? (
              <Alert severity="success">{successMessage}</Alert>
            ) : null}
            <div>
              <TextField
                id="standard-basic"
                autoComplete="nope"
                label="Login ID"
                onChange={(e) => this.setState({ loginID: e.target.value })}
                value={loginID}
              />
            </div>
            <div>
              <TextField
                id="standard-basic1"
                autoComplete="nope"
                label="Name"
                onChange={(e) =>
                  this.setState({ employeeName: e.target.value })
                }
                value={employeeName}
              />
            </div>
            <div>
              <FormControl>
                <InputLabel id="demo-simple-select-autowidth-label">
                  Choose Language
                </InputLabel>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={baseLanguage}
                  onChange={(e) =>
                    this.setState({ baseLanguage: e.target.value })
                  }
                  // autoWidth
                  label="Language"
                >
                  <MenuItem value="">
                    <em>---Select---</em>
                  </MenuItem>
                  {baseLanguageFilter &&
                    baseLanguageFilter.map((element) => {
                      return <MenuItem value={element}>{element}</MenuItem>;
                    })}
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <InputLabel id="demo-simple-select-autowidth-label1">
                  Choose College
                </InputLabel>
                <Select
                  labelId="demo-simple-select-autowidth-label1"
                  id="demo-simple-select-autowidth1"
                  value={collegeId}
                  onChange={(e) => this.setState({ collegeId: e.target.value })}
                  // autoWidth
                  label="College"
                >
                  <MenuItem value="">
                    <em>---Select---</em>
                  </MenuItem>
                  {collegeList &&
                    collegeList.map((element) => {
                      return (
                        <MenuItem value={element.College_id}>
                          {element.College_name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>

            {/* <div>
              <TextField
                type="password"
                autoComplete="new-password"
                id="standard-basic"
                label="Password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </div> */}

            <div className="login-btn-wrapper">
              <Button
                type="submit"
                disabled={
                  password.length >= 1 &&
                  loginID.length >= 1 &&
                  collegeId !== "" &&
                  employeeName !== ""
                    ? false
                    : true
                }
                //  onClick={() => this.props.history.push("/dashboard")}
                variant="contained"
                color="primary"
                disableElevation
              >
                Register
              </Button>
            </div>
            <br />
            <br />
            <div style={{ textAlign: "right" }}>
              <a href="/"> Click Here to Login</a>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { AudioToTrackReducer, SuperAdminReducer } = state;
  return {
    AudioToTrackReducer,
    SuperAdminReducer,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCollegeList: () => dispatch(fetchCollegeList()),
  fetchUserLanguages: () => dispatch(fetchUserLanguages()),
  registerNewUser: (
    LoginId,
    Password,
    BaseLanguage,
    OtherLanguages,
    UserPrivilege,
    Createdby,
    EmployeeName,
    ProductIds,
    TeamId,
    CollegeId
  ) =>
    dispatch(
      registerNewUser(
        LoginId,
        Password,
        BaseLanguage,
        OtherLanguages,
        UserPrivilege,
        Createdby,
        EmployeeName,
        ProductIds,
        TeamId,
        CollegeId
      )
    ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Register)
);
